<template>
	<v-container grid-list-xl>
		<v-form v-model="isAddValid">
			<v-layout row wrap>
				<v-flex lg6>
					<label class="blackLabel">* Token Name:</label>
					<v-text-field label="Name" v-model="tokenName" required :rules="nameRules" single-line solo></v-text-field>
				</v-flex>
				<v-flex lg6>
					<label class="blackLabel">Token Value:</label>
					<p>{{ tokenValue }}</p>
				</v-flex>
				<div class="pl-4 pr-1 pb-4 buttonHolder">
					<div style="float: right">
						<v-btn color="success" class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
						<v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
            <v-btn color="success" :disabled="!isAddValid" class="text-xs-right" @click.stop="fncAddToken()">Save</v-btn>
            <!--<v-btn color="success" class="text-xs-right" :disabled="!isAddValid" @click.stop="fncAddToken()">Save</v-btn>-->
            <small>* The button will activate once all required fields have been completed</small>
					</div>
				</div>
			</v-layout>
		</v-form>
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex';
	export default {
	  name: 'Settings',
	  data () {
			return {
              isAddValid: false,
                search: '',
                tokenName: '',
                regionHeader: [
                  { text: 'Select', value: '' },
                  { text: 'Name', value: 'name' }
                ],
                tokenValue: this.fncCreateToken(32),
                nameRules: [
                  v => !!v || 'Token name is required',
                ],
                addressSelected: false
			};
		},
		methods: {
     fncCreateToken(length) {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
      },
			fncHideModal () {
				this.$store.commit('hideModal');
          },
            fncCheckRegionSetup(regionId, regionStatus, regionParent) {
              this.addressSelected = true;
              this.$store.commit({
                type: 'fncCheckRegionSetup',
                regionId: regionId,
                regionStatus: regionStatus,
                parent: regionParent
              })
              if (regionStatus == false) {
                this.$store.commit('fncHideRegionParent', regionParent)
              }
            },
			fncAddToken() {
				this.$store.dispatch({
          type: 'fncAddToken',
          tokenName: this.tokenName,
          tokenValue: this.tokenValue
				});
			}
		},
		computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams',
                'runAdd',
                'userRegions'
			])
		},
        created() {
          this.$store.dispatch('fncPopulateRegionList');
        }
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>
